<template>
  <div class="tw-flex tw-h-screen tw-flex-col">
    <!-- Mobile layout -->
    <div class="tw-flex tw-h-full tw-flex-col sm:tw-hidden">
      <div :class="headerNav" class="safe-area-top">
        <div
          v-if="cobrandedExperience"
          class="tw-flex tw-w-full tw-items-center tw-justify-center tw-py-4"
        >
          <CaseWiseHeaderLogo />
        </div>
      </div>

      <div class="tw-h-full tw-flex-1 tw-overflow-auto" :class="headerNav">
        <div
          class="safe-area-bottom tw-flex tw-h-full tw-grow tw-flex-col tw-rounded-t-[30px] tw-bg-white"
        >
          <!-- ERROR CONTENT -->
          <div class="tw-flex tw-h-full tw-grow tw-px-6 tw-pb-10 tw-pt-8">
            <slot />
          </div>
        </div>
        <!-- FOOTER BELOW FORM CONTAINER -->
        <SiteFooter :theme="authFooter" class="safe-area-bottom sm:tw-hidden" />
      </div>
    </div>

    <!-- Desktop and tablet layout -->
    <div class="tw-hidden tw-h-full tw-w-full tw-flex-col sm:tw-flex">
      <div class="tw-flex tw-w-full tw-grow">
        <div
          class="tw-flex tw-h-full tw-w-1/2 tw-flex-col tw-items-center tw-justify-center tw-bg-gradient-to-t"
          :class="[cobrandedExperience ? linearGradient : 'tw-bg-white']"
        >
          <Component
            :is="cobrandedExperience ? CaseWiseLoginLogo : 'img'"
            :src="!cobrandedExperience ? cobrandedLogoUrl : undefined"
            :alt="cobrandedExperience ? branding.name : 'CaseWise'"
            class="tw-h-auto tw-w-[256px] lg:tw-w-[430px] lg:tw-max-w-[430px]"
          />
        </div>

        <!-- Right side - Auth components -->
        <div
          class="tw-flex tw-h-full tw-w-1/2 tw-flex-col tw-items-center tw-justify-center tw-bg-gradient-to-t tw-px-6 tw-py-4 lg:tw-px-8 xl:tw-px-24"
          :class="[cobrandedExperience ? 'tw-bg-white' : linearGradient]"
        >
          <div
            class="tw-flex tw-flex-col tw-items-start tw-gap-6 tw-rounded-xl tw-bg-white tw-p-10"
          >
            <slot />
          </div>
        </div>
      </div>

      <SiteFooter :theme="authFooter" />
    </div>
  </div>
</template>

<script setup lang="ts">
import CaseWiseHeaderLogo from '~/assets/icons/CaseWiseHeaderLogo.svg'
import CaseWiseLoginLogo from '~/assets/icons/CaseWiseLoginLogo.svg'

const { getThemeToken, getThemeTokenString } = useTheme()
const authFooter = getThemeToken('auth-footer')
const linearGradient = getThemeToken('linear-gradient')
const headerNav = getThemeTokenString('header-nav')

const branding = useBrand()
const cobrandedExperience = computed(() => branding.value.brandingExperience === 'cobrand')

const cobrandedLogoUrl = computed(() => {
  return branding.value.svgLogoUrl || branding.value.pngLogoUrl
})
</script>

<style scoped>
.safe-area-top {
  padding-top: calc(env(safe-area-inset-top) - 12px);
}

.safe-area-bottom {
  padding-bottom: calc(env(safe-area-inset-bottom) / 3);
}
</style>
